export default __webpack_public_path__ + "static/media/cutout-ai.e606b78c.jpg";